import { render, staticRenderFns } from "./rankBox.vue?vue&type=template&id=236f7adf&scoped=true&"
import script from "./rankBox.vue?vue&type=script&setup=true&lang=js&"
export * from "./rankBox.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./rankBox.vue?vue&type=style&index=0&id=236f7adf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236f7adf",
  null
  
)

export default component.exports